/**
 * Subimods Support Hub — category switching + cross-topic search
 * Expects root: [data-sm-support-hub]
 * Docs: SM-SUPPORT-PAGES.md
 */
(function () {
  'use strict';

  var SEARCH_KEY = 'search-results';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(value) {
    return (value || '')
      .toLowerCase()
      .replace(/[^\w\s+]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isMobileNav() {
    return window.matchMedia('(max-width: 899px)').matches;
  }

  function initRoot(root) {
    if (!root || root.dataset.smHubReady === 'true') return;
    root.dataset.smHubReady = 'true';

    var input = root.querySelector('[data-sm-hub-search]');
    var clearBtn = root.querySelector('[data-sm-hub-clear]');
    var meta = root.querySelector('[data-sm-hub-meta]');
    var emptySearch = root.querySelector('[data-sm-hub-empty-search]');
    var emptyNone = root.querySelector('[data-sm-hub-empty-none]');
    var heading = root.querySelector('[data-sm-hub-heading]');
    var panelHead = root.querySelector('[data-sm-hub-panel-head]');
    var pageLink = root.querySelector('[data-sm-hub-page-link]');
    var nav = root.querySelector('[data-sm-hub-nav]');
    var navCurrent = root.querySelector('[data-sm-hub-nav-current]');
    var catButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sm-hub-cat]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sm-hub-item]'));

    var activeCategory = SEARCH_KEY;
    var lastBrowsedCategory = SEARCH_KEY;
    var categoryLabels = {};

    catButtons.forEach(function (btn) {
      var key = btn.getAttribute('data-sm-hub-cat') || '';
      var labelEl = btn.querySelector('span:last-child');
      categoryLabels[key] = labelEl ? labelEl.textContent.trim() : key;
    });

    function setMeta(text) {
      if (meta) meta.textContent = text || '';
    }

    function setClearVisible(visible) {
      if (!clearBtn) return;
      clearBtn.classList.toggle('is-visible', !!visible);
    }

    function setActiveButton(key) {
      catButtons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-sm-hub-cat') === key;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateNavCurrent(key) {
      if (!navCurrent) return;
      navCurrent.textContent = categoryLabels[key] || key;
    }

    function closeMobileNav() {
      if (nav && isMobileNav()) {
        nav.open = false;
      }
    }

    function updateHeading(key, query) {
      var showingSearch = key === SEARCH_KEY || !!query;

      if (panelHead) {
        panelHead.hidden = showingSearch;
      }

      if (showingSearch) {
        if (heading) heading.textContent = '';
        if (pageLink) {
          pageLink.hidden = true;
          pageLink.removeAttribute('href');
        }
        return;
      }

      var label = categoryLabels[key] || key;
      if (heading) heading.textContent = label;

      if (!pageLink) return;
      var activeBtn = root.querySelector('[data-sm-hub-cat="' + key + '"]');
      var pageUrl = activeBtn ? activeBtn.getAttribute('data-sm-hub-page-url') || '' : '';
      if (pageUrl) {
        pageLink.href = pageUrl;
        pageLink.hidden = false;
      } else {
        pageLink.hidden = true;
        pageLink.removeAttribute('href');
      }
    }

    function closeAllItems() {
      items.forEach(function (item) {
        item.open = false;
      });
    }

    function render() {
      var query = input ? normalize(input.value) : '';
      var matchCount = 0;
      var viewingSearch = !!query || activeCategory === SEARCH_KEY;

      items.forEach(function (item) {
        var category = item.getAttribute('data-category') || '';
        var haystack = normalize(item.getAttribute('data-search') || item.textContent);
        var matches = false;

        if (query) {
          // Search always overrides category and matches across all topics
          matches = haystack.indexOf(query) !== -1;
        } else if (activeCategory === SEARCH_KEY) {
          matches = false;
        } else {
          matches = category === activeCategory;
        }

        item.classList.toggle('is-hidden', !matches);
        item.classList.toggle('is-match', !!(query && matches));
        if (matches) matchCount += 1;
      });

      var showEmptySearch = viewingSearch && !query;
      var showEmptyNone = !showEmptySearch && matchCount === 0;

      if (emptySearch) emptySearch.classList.toggle('is-visible', showEmptySearch);
      if (emptyNone) emptyNone.classList.toggle('is-visible', showEmptyNone);

      if (query) {
        if (matchCount === 0) {
          setMeta('No matching questions');
        } else {
          setMeta(matchCount + (matchCount === 1 ? ' question found' : ' questions found'));
        }
        updateNavCurrent(SEARCH_KEY);
        setActiveButton(SEARCH_KEY);
      } else if (activeCategory === SEARCH_KEY) {
        setMeta('');
        updateNavCurrent(SEARCH_KEY);
        setActiveButton(SEARCH_KEY);
      } else {
        setMeta(matchCount + (matchCount === 1 ? ' question' : ' questions'));
        updateNavCurrent(activeCategory);
        setActiveButton(activeCategory);
      }

      setClearVisible(!!query);
      updateHeading(activeCategory, query);
    }

    function selectCategory(key, options) {
      options = options || {};
      if (options.clearSearch && input) {
        input.value = '';
      }
      activeCategory = key || SEARCH_KEY;
      if (activeCategory !== SEARCH_KEY) {
        lastBrowsedCategory = activeCategory;
      }
      setActiveButton(activeCategory);
      updateNavCurrent(activeCategory);
      closeAllItems();
      if (options.closeNav !== false) {
        closeMobileNav();
      }
      render();
    }

    catButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-sm-hub-cat') || SEARCH_KEY;
        selectCategory(key, { clearSearch: true, closeNav: true });
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        var q = normalize(input.value);
        if (q) {
          if (activeCategory !== SEARCH_KEY) {
            lastBrowsedCategory = activeCategory;
          }
          activeCategory = SEARCH_KEY;
          closeAllItems();
          closeMobileNav();
        } else if (lastBrowsedCategory && lastBrowsedCategory !== SEARCH_KEY) {
          // Leaving search returns to the last browsed category
          activeCategory = lastBrowsedCategory;
          closeAllItems();
        }
        render();
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (input) input.value = '';
        if (lastBrowsedCategory && lastBrowsedCategory !== SEARCH_KEY) {
          selectCategory(lastBrowsedCategory, { clearSearch: true, closeNav: false });
        } else {
          selectCategory(SEARCH_KEY, { clearSearch: true, closeNav: false });
        }
        if (input) input.focus();
      });
    }

    // Deep-link: ?view=help-center#hub-returns-refunds-can-i-return-an-item
    if (window.location.hash) {
      var target = root.querySelector(window.location.hash);
      if (target && target.matches('[data-sm-hub-item]')) {
        var cat = target.getAttribute('data-category') || SEARCH_KEY;
        selectCategory(cat, { clearSearch: true });
        target.classList.remove('is-hidden');
        target.open = true;
        var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
        return;
      }
    }

    // Mobile starts collapsed; desktop keeps the sidebar open via [open] + CSS
    if (nav && isMobileNav()) {
      nav.open = false;
    }

    selectCategory(SEARCH_KEY, { clearSearch: true, closeNav: true });
  }

  function initAll() {
    document.querySelectorAll('[data-sm-support-hub]').forEach(initRoot);
  }

  ready(initAll);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-sm-support-hub]');
    if (root) {
      root.dataset.smHubReady = 'false';
      initRoot(root);
    }
  });
})();
